<template>
<div>
 <!-- Hero Start -->
<!--        <section class="bg-half bg-light d-table w-100">-->
<!--            <div class="container">-->
<!--                <div class="row justify-content-center">-->
<!--                    <div class="col-lg-12 text-center">-->
<!--                        <div class="title-heading">-->
<!--                            <h4>Blog Or News</h4>-->
<!--                            <p class="text-muted para-desc mx-auto mt-3 mb-0">We present and write attractive blog posts</p>-->
<!--                            <nav aria-label="breadcrumb" class="d-inline-block mt-4">-->
<!--                                <ul class="breadcrumb mb-0">-->
<!--                                    <li class="breadcrumb-item"><a href="index.html">Appdesk</a></li>-->
<!--                                    <li class="breadcrumb-item active" aria-current="page">Blog</li>-->
<!--                                </ul>-->
<!--                            </nav>-->
<!--                        </div>-->
<!--                    </div>&lt;!&ndash;end col&ndash;&gt;-->
<!--                    <div class="home-shape-arrow">-->
<!--                        <a href="blog.html#blog" class="scroll-down"><i class="mdi mdi-arrow-down arrow-icon bg-light text-dark h5"></i></a>-->
<!--                    </div>-->
<!--                </div>&lt;!&ndash;end row&ndash;&gt;-->
<!--            </div> &lt;!&ndash;end container&ndash;&gt;-->
<!--        </section>&lt;!&ndash;end section&ndash;&gt;-->
        <!-- Hero End -->
        <!-- Start BLog -->
        <section class="section" id="blog">
            <div class="container" style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-items: center;margin-top: 2%">
              <h4 class="title mb-4">资质证书</h4>

              <div class="col-lg-9">    <p class="text-indent text-muted mb-0">爱拚氪自主研发云原生数字化教育系统“爱拼考”，以稳定安全的、智能高效的在线培训考试系统，为客户制定覆盖整个培训考试全生命周期的、全方位的技术解决方案，助力搭建“学+练+考+评”全生态链服务体系。截至2021年4月，爱拚氪已取得软件著作权12项、注册商标1项，通过CMA和CNAS等系列产品认证。</p></div>
                <div class="row justify-center justify-content-center mt-4"  style="width: 70%">
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                          <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/ruanzhu1.png" class="img-fluid" alt="missing-image">
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                          <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/ruanzhu2.png" class="img-fluid" alt="missing-image">
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                          <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/ruanzhu3.png" class="img-fluid" alt="missing-image">
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                          <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/ruanzhu4.png" class="img-fluid" alt="missing-image">
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                          <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/ruanzhu5.png" class="img-fluid" alt="missing-image">
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/ruanzhu6.png" class="img-fluid" alt="missing-image">
                        </div>
                    </div><!--end col-->



                  <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                    <div class="card blog-post border-0 rounded overflow-hidden shadow">
                      <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/%E8%B5%84%E8%B4%A8%E8%AF%81%E4%B9%A6/31621525463_.pic_hd.jpg" class="img-fluid" alt="missing-image">
                    </div>
                  </div><!--end col-->

                  <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                    <div class="card blog-post border-0 rounded overflow-hidden shadow">
                      <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/%E8%B5%84%E8%B4%A8%E8%AF%81%E4%B9%A6/41621525464_.pic_hd.jpg" class="img-fluid" alt="missing-image">
                    </div>
                  </div><!--end col-->

                  <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                    <div class="card blog-post border-0 rounded overflow-hidden shadow">
                      <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/%E8%B5%84%E8%B4%A8%E8%AF%81%E4%B9%A6/51621525465_.pic_hd.jpg" class="img-fluid" alt="missing-image">
                    </div>
                  </div><!--end col-->

                  <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                    <div class="card blog-post border-0 rounded overflow-hidden shadow">
                      <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/%E8%B5%84%E8%B4%A8%E8%AF%81%E4%B9%A6/61621525466_.pic_hd.jpg" class="img-fluid" alt="missing-image">
                    </div>
                  </div><!--end col-->

                  <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                    <div class="card blog-post border-0 rounded overflow-hidden shadow">
                      <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/%E8%B5%84%E8%B4%A8%E8%AF%81%E4%B9%A6/71621525467_.pic_hd.jpg" class="img-fluid" alt="missing-image">
                    </div>
                  </div><!--end col-->

                  <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                    <div class="card blog-post border-0 rounded overflow-hidden shadow">
                      <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/%E8%B5%84%E8%B4%A8%E8%AF%81%E4%B9%A6/81621525468_.pic_hd.jpg" class="img-fluid" alt="missing-image">
                    </div>
                  </div><!--end col-->





  <div class="col-lg-4 col-md-6 col-12 mb-4 pb-3">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/161621526375_.pic_hd.jpg" class="img-fluid" alt="missing-image">
                        </div>
                    </div><!--end col-->

                </div><!--end row-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- End BLog -->


</div>
</template>

<script>


export default {
  components: {
  
  }
}
</script>


